var _defs, _use;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNeedReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "need-review-a",
    d: "M8.99607849,21.9095785 L13.875,18.2494146 L19.5,18.2494146 C20.8788986,18.2494146 22,17.1283133 22,15.7494146 L22,4.49941463 C22,3.12051601 20.8788986,1.99941463 19.5,1.99941463 L4.5,1.99941463 C3.12110138,1.99941463 2,3.12051601 2,4.49941463 L2,15.7494146 C2,17.1283133 3.12110138,18.2494146 4.5,18.2494146 L8.25,18.2494146 L8.25,21.5306646 C8.25,21.9134695 8.68750763,22.1361334 8.99607849,21.9095785 Z M14.5,9.296282 C13.9218826,9.296282 13.4531326,8.827532 13.4531326,8.24941463 C13.4531326,7.67129726 13.9218826,7.20254726 14.5,7.20254726 C15.0781174,7.20254726 15.5468674,7.67129726 15.5468674,8.24941463 C15.5468674,8.827532 15.0781174,9.296282 14.5,9.296282 Z M9.5,9.296282 C8.92188263,9.296282 8.45313263,8.827532 8.45313263,8.24941463 C8.45313263,7.67129726 8.92188263,7.20254726 9.5,7.20254726 C10.0781174,7.20254726 10.5468674,7.67129726 10.5468674,8.24941463 C10.5468674,8.827532 10.0781174,9.296282 9.5,9.296282 Z M12,14.4994146 C10.4843826,14.4994146 9.05860138,13.8470633 8.08592987,12.7064306 C7.859375,12.4447424 7.89061737,12.0501883 8.15623474,11.8275244 C8.41796112,11.6048986 8.81251526,11.6322119 9.03514099,11.8978674 C9.76954651,12.7572424 10.8515472,13.2494146 11.996109,13.2494146 C13.1445236,13.2494146 14.2226715,12.7572424 14.9570389,11.8939383 C15.1835938,11.6322119 15.5781097,11.6009695 15.8398361,11.8236334 C16.1054535,12.0501883 16.136734,12.4447424 15.9140701,12.7064306 C14.9413986,13.8470633 13.5156174,14.4994146 12,14.4994146 Z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#40B3DB",
    transform: "matrix(-1 0 0 1 24 0)",
    xlinkHref: "#need-review-a"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeedReview);
export default __webpack_public_path__ + "static/media/need-review.f1797252.svg";
export { ForwardRef as ReactComponent };